do ($ = jQuery, window, document) ->
  pluginName = "tededCardlist"
  defaults =
    slider: '[data-slider]'
    container: '[data-cardcontainer]'

  # Debounce and SmartResize (in jQuery) ported to CoffeeScript
  # debouncing function from John Hann
  # http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  debounce = (func, threshold, execAsap) ->
    timeout = false

    return debounced = ->
      obj = this
      args = arguments

      delayed = ->
        func.apply(obj, args) unless execAsap
        timeout = null

      if timeout
        clearTimeout(timeout)
      else if (execAsap)
        func.apply(obj, args)

      timeout = setTimeout delayed, threshold || 100

  class TededCardlist
    constructor: (@element, options) ->
      @settings = $.extend {}, defaults, options
      @$element = $(@element)
      @responsive = @$element.data("responsive") ||false
      @index = @$element.data("start-on") || @settings.initialSlide || 0
      @$prev = new $('<button title="Previous"/>').addClass "tdd-btn__arrow tdd-btn__arrow--prev"
      @$next = new $('<button title="Next"/>').addClass "tdd-btn__arrow tdd-btn__arrow--next"
      @$slider = @$element.find(@settings.slider)
      @$slides = @$slider.children() if @$slider.length
      @$container = @$element.find(@settings.container)
      @maxIndex = @$slides.length - 1
      if @$slides.length < 1
        console.error 'No slides found.'
        return false
      @init()

    appendBtn: ($btn, dir) ->
      if @responsive
        classes = "tdd-cardlist__btn-wrap tdd-cardlist__btn-wrap--#{dir}"
        wrapper = new $('<div />').addClass(classes).append($btn)
        wrapper.appendTo(@$element)
      else
        $btn.appendTo(@$element)

    init: ->
      if @$element.find(@$next).length < 1
        @$next.on "click.#{pluginName}.next", (e) =>
          e.preventDefault()
          e.target.blur()
          @next()
        @appendBtn(@$next, 'next')

      if @$element.find(@$prev).length < 1
        @$prev.on "click.#{pluginName}.prev", (e) =>
          e.preventDefault()
          e.target.blur()
          @prev(e)
        @appendBtn(@$prev, 'prev')

      if @index > 0 
        @goTo(@index)

      @updateBtns()

      # Bind events
      $(window).on "resize", debounce(@afterResize, 300)
      return

    afterResize: =>
      @goTo(@index)

    next: ->
      @goTo Math.min @index + 1, @$slides.length

    prev: ->
      @goTo Math.max @index - 1, 0

    goTo: (index) ->
      @checkLastViewportSlide()
      @index = Math.min(index, @maxIndex)
      $slide = @$slides.eq(@index)
      return false if $slide.length == 0

      @updateBtns()
      offsetX = $slide.get(0).offsetLeft * -1
      @$slider.css 'transform', "translate3d(#{Math.ceil(offsetX)}px, 0, 0)"
      return

    checkLastViewportSlide: (idx) ->
      viewPort = @$container.get(0).getBoundingClientRect().width
      slideWidth = @$slides[0].getBoundingClientRect().width
      groups = Math.floor( viewPort / slideWidth )
      @maxIndex = @$slides.length - groups
      return

    updateBtns: ->
      @toggleBtn(@$prev, @index > 0)
      @toggleBtn(@$next, @index < @maxIndex && @index < @$slides.length - 1)

    toggleBtn: ($btn, active) ->
      $btn.css 'opacity', +(active)
      if (active)
        $btn.removeAttr('disabled')
      else
        $btn.attr('disabled', "disabled")

  $.fn[pluginName] = (options) ->
    @each ->
      if !$.data(@, "plugin_#{pluginName}")
        $.data(@, "plugin_#{pluginName}", new TededCardlist(@, options))

$ ->
  $('[data-cardlist]').tededCardlist()
  $(document).ajaxComplete () ->
    $('[data-cardlist]').tededCardlist()